import {
  initPassword,
  ACTION_NAMES,
} from '../../../../actions/actions';
import Localization from '../../../../assets/localization';

const initialState = {
  loading: false,
};

export function cleanState() {
  return (dispatch) => {
    dispatch({ type: ACTION_NAMES.SET_EMAIL_INITIAL_STATE });
  };
}

export function backToLoginClick() {
  return (dispatch) => {
    dispatch({ type: ACTION_NAMES.BACK_TO_LOGIN_CLICKED });
  };
}

export function setEmail(email) {
  return (dispatch) => {
    dispatch({ type: ACTION_NAMES.SET_EMAIL_REQUEST_START });

    initPassword(email).then(() => {
      dispatch({ type: ACTION_NAMES.SET_EMAIL_REQUEST_SUCCESS, email });
    }).catch((response = {}) => {
      const errorMessage = (response.response && response.response.data
        && response.response.data.title)
        || Localization.INTERNAL_ERROR_MESSAGE;
      dispatch({ type: ACTION_NAMES.SET_EMAIL_REQUEST_FAIL, error: errorMessage });
    });
  };
}

export default function setEmailReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTION_NAMES.SET_EMAIL_INITIAL_STATE:
      return { ...initialState, email: state.email };

    case ACTION_NAMES.SET_EMAIL_REQUEST_START:
      return { ...state, loading: true };

    case ACTION_NAMES.SET_EMAIL_REQUEST_SUCCESS:
      return { ...state,
        loading: false,
        success: true,
        email: action.email };

    case ACTION_NAMES.SET_EMAIL_REQUEST_FAIL:
      return { ...state,
        loading: false,
        success: false,
        error: action.error };

    default:
      return { ...state };
  }
}
